<div class="loader-container">
  <div class="scanner-container">
    <div class="scanner">
      <div class="scan-line"></div>
      <img
        [src]="imageSrc"
        alt="Scanning Image"
        class="scanned-image"
      />
    </div>
    <div class="scanned-percentage-complete">{{ percentageComplete }}</div>
  </div>
</div>
